import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('Container', ContainerData);

    ContainerData.$inject = ['$translate'];

    /* @ngInject */
    function ContainerData($translate) {
        Container.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getDematModeTranslated: getDematModeTranslated,
            getContainerTypeTranslated: getContainerTypeTranslated,
            getContainerStatusTranslated: getContainerStatusTranslated,
            getTreatment: getTreatment
        };

        function Container(containerData) {
            if (!containerData) {
                this.buildEmpty();
            } else {
                this.build(containerData);
            }
        }

        return Container;

        /////////////////////

        function buildEmpty() {
            this.containerId = null;
            this.perimeterCode = null;
            this.containerMode = null;
            this.containerType = null;
            this.dematMode = null;
            this.ladProviderName = null;
            this.containerStatus = null;
            this.dematPlatformId = null;
            this.mappingFilename = null;
            this.traitementType = null;
        }

        function build(containerData) {
            this.containerId = containerData.containerId || null;
            this.perimeterCode = containerData.perimeterCode || null;
            this.containerMode = containerData.containerMode || null;
            this.containerType = containerData.containerType || null;
            this.dematMode = containerData.dematMode || null;
            this.ladProviderName = containerData.ladProviderName || null;
            this.containerStatus = containerData.containerStatus || null;
            this.dematPlatformId = containerData.dematPlatformId || null;
            this.mappingFilename = containerData.mappingFilename || null;
            this.traitementType = containerData.traitementType || null;
        }

        function getContainerStatusTranslated() {
            return $translate.instant(angular.uppercase(this.containerStatus));
        }

        function getContainerTypeTranslated() {
            return $translate.instant(angular.uppercase(this.containerType));
        }

        function getDematModeTranslated() {
            return $translate.instant(angular.uppercase(this.dematMode));
        }

        function getTreatment() {
            var genMappings = { P: 'Générique PASREL', G: 'Générique GIS' };
            return this.traitementType === 'GENERIC' ? genMappings[this.dematPlatformId] : this.mappingFilename;
        }
    }
})();
